import { jsx as _jsx } from "react/jsx-runtime";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { AVERAGE_SHIPPING_COSTS, INSIDER_ANNUAL_MEMBERSHIP_COST, INSIDER_ANNUAL_MEMBERSHIP_SAVINGS, INSIDER_MONTHLY_MEMBERSHIP_COST, INSIDER_MONTHLY_MEMBERSHIP_SAVINGS } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/consts";
import { InsiderSavingsSummary } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderSavingsSummary";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { formatMoney, moneyOrZero, RoundingStrategy } from "@faire/web--source/common/money";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import { useQuery as useInsiderMarketingPageData } from "@faire/web-api--source/api/retailer/insider/marketing-page/get-hooks";
import React from "react";
export var InsiderSavingsSummaryRenderer = function(param) {
    var isEligibleForAnnualBilling = param.isEligibleForAnnualBilling;
    var hasFreeDutyAdvertising = useInsiderFeatureEligibility().hasFreeDutyAdvertising;
    if (hasFreeDutyAdvertising) {
        return /*#__PURE__*/ _jsx(InternationalSavingsSummary, {});
    }
    return /*#__PURE__*/ _jsx(USSavingsSummary, {
        isEligibleForAnnualBilling: isEligibleForAnnualBilling
    });
};
var DefaultSavingsSummary = function(param) {
    var title = param.title, _param_savings = param.savings, shippingSavings = _param_savings.shippingSavings, dutiesSavings = _param_savings.dutiesSavings, totalSavings = _param_savings.totalSavings, isLoading = param.isLoading;
    return /*#__PURE__*/ _jsx(InsiderSavingsSummary, {
        title: title !== null && title !== void 0 ? title : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "gYGeQQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "After just one order*, your membership pays for itself"
                }
            ]
        }),
        items: [
            {
                name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "EwWEpC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Average shipping per order"
                        }
                    ]
                }),
                amount: /*#__PURE__*/ _jsx(Money, {
                    money: moneyOrZero(shippingSavings),
                    roundingStrategy: RoundingStrategy.DROP_CENTS
                }),
                strikethrough: true
            },
            {
                name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "tgl+jz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Average duties per order"
                        }
                    ]
                }),
                amount: /*#__PURE__*/ _jsx(Money, {
                    money: moneyOrZero(dutiesSavings),
                    roundingStrategy: RoundingStrategy.DROP_CENTS
                }),
                strikethrough: true
            }
        ],
        total: {
            name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "kpuCRZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Savings with Insider"
                    }
                ]
            }),
            amount: moneyOrZero(totalSavings)
        },
        isLoading: isLoading
    });
};
var InternationalSavingsSummary = function() {
    var _useInsiderMarketingPageData = useInsiderMarketingPageData(), data = _useInsiderMarketingPageData.data, isLoading = _useInsiderMarketingPageData.isLoading;
    return /*#__PURE__*/ _jsx(DefaultSavingsSummary, {
        isLoading: isLoading,
        savings: {
            shippingSavings: data === null || data === void 0 ? void 0 : data.insider_shipping_saving,
            dutiesSavings: data === null || data === void 0 ? void 0 : data.insider_duties_saving,
            totalSavings: data === null || data === void 0 ? void 0 : data.insider_saving_total
        }
    });
};
var USSavingsSummary = function(param) {
    var isEligibleForAnnualBilling = param.isEligibleForAnnualBilling;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(InsiderSavingsSummary, {
        title: strictLocalize({
            id: "7Sw0t4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Insider pays for itself"
                }
            ]
        }),
        items: [
            {
                name: strictLocalize({
                    id: "A9EcOJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Average shipping costs"
                        }
                    ]
                }),
                amount: formatMoney({
                    money: AVERAGE_SHIPPING_COSTS,
                    roundingStrategy: RoundingStrategy.DROP_CENTS
                })
            },
            {
                name: isEligibleForAnnualBilling ? strictLocalize({
                    id: "ZEpY4R",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Insider membership*"
                        }
                    ]
                }) : strictLocalize({
                    id: "db//0i",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Insider membership"
                        }
                    ]
                }),
                amount: isEligibleForAnnualBilling ? formatMoney({
                    money: INSIDER_ANNUAL_MEMBERSHIP_COST
                }) : formatMoney({
                    money: INSIDER_MONTHLY_MEMBERSHIP_COST
                })
            }
        ],
        total: {
            name: isEligibleForAnnualBilling ? strictLocalize({
                id: "zKlU5M",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Monthly savings**"
                    }
                ]
            }) : strictLocalize({
                id: "spB5PS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Monthly savings*"
                    }
                ]
            }),
            amount: isEligibleForAnnualBilling ? INSIDER_ANNUAL_MEMBERSHIP_SAVINGS : INSIDER_MONTHLY_MEMBERSHIP_SAVINGS
        }
    });
};
